import {
  Drawer,
  TextInput,
  Select,
  NumberInput,
  Button,
  Group,
  Stack,
  Checkbox,
  Text,
  ActionIcon
} from "@mantine/core";

import { IconX } from "@tabler/icons-react";
import { useState, useEffect } from "react";

const RatePlansDrawer = ({
  show,
  onHide,
  rooms = [],
  onCreate,
  onUpdate,
  hotelId,
  editingPlan
}) => {

  const [name, setName] = useState("");
  const [mealPlan, setMealPlan] = useState("none");
  const [policyType, setPolicyType] = useState("free");
  const [penaltyPercentage, setPenaltyPercentage] = useState(0);
  const [hoursBeforeArrival, setHoursBeforeArrival] = useState(24);
  const [selectedRooms, setSelectedRooms] = useState([]);

  const [daysOfWeek, setDaysOfWeek] = useState([]);


  const isEdit = Boolean(editingPlan);

  useEffect(() => {

    if (editingPlan) {

      setName(editingPlan.name || "");
      setMealPlan(editingPlan.mealPlan || "none");
      setHoursBeforeArrival(
        editingPlan.cancellationPolicy?.hoursBeforeArrival || 24
      );
      console.log("editingPlan.rooms", editingPlan.rooms);

      setSelectedRooms(
        editingPlan.rooms?.map(r => r._id.toString()) || []
      );
      setPolicyType(editingPlan.cancellationPolicy?.type || "free");
      setPenaltyPercentage(editingPlan.cancellationPolicy?.penaltyPercentage || 0);

  
      setDaysOfWeek(editingPlan.daysOfWeek || []);
    }

  }, [editingPlan]);

  const handleRoomToggle = (roomId) => {

  const id = roomId.toString();

  setSelectedRooms(prev =>
    prev.includes(id)
      ? prev.filter(i => i !== id)
      : [...prev, id]
  );

};

  const handleDayToggle = (day) => {

    setDaysOfWeek(prev =>
      prev.includes(day)
        ? prev.filter(d => d !== day)
        : [...prev, day]
    );

  };

  const resetForm = () => {

    setName("");
    setMealPlan("none");
    setHoursBeforeArrival(24);
    setSelectedRooms([]);
    setDaysOfWeek([]);
    setPolicyType("free");
    setPenaltyPercentage(0);

  };

  const handleSubmit = (e) => {

    e.preventDefault();

    if (!name.trim()) return;

    if (selectedRooms.length === 0) {
      alert("Sélectionnez au moins une chambre");
      return;
    }


    const payload = {
      hotelId,
      name: name.trim(),
      rooms: selectedRooms,
      cancellationPolicy: {
        type: policyType,
        hoursBeforeArrival: Number(hoursBeforeArrival),
        penaltyPercentage: Number(penaltyPercentage)
      },
      mealPlan,
      daysOfWeek,

    };

    if (isEdit) {
      onUpdate(editingPlan._id, payload);
    } else {
      onCreate(payload);
    }

    resetForm();
    onHide();

  };

  const days = [
    { label: "Lun", value: 1 },
    { label: "Mar", value: 2 },
    { label: "Mer", value: 3 },
    { label: "Jeu", value: 4 },
    { label: "Ven", value: 5 },
    { label: "Sam", value: 6 },
    { label: "Dim", value: 0 }
  ];

  return (

    <Drawer
      opened={show}
      onClose={() => {
        resetForm();
        onHide();
      }}
      title={isEdit ? "Modifier le tarif" : "Créer un tarif"}
      position="right"
      size="md"
    >

      <form onSubmit={handleSubmit}>

        <Stack gap={24}>

          <TextInput
            label="Nom du tarif"
            placeholder="Ex : Weekend"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />

      

          <Text fw={600}>Jours de la semaine</Text>

          <Group>

            {days.map(day => (

              <Button
                key={day.value}
                size="xs"
                variant={daysOfWeek.includes(day.value) ? "filled" : "light"}
                color="green"
                onClick={() => handleDayToggle(day.value)}
              >
                {day.label}
              </Button>

            ))}

          </Group>

          <Select
            label="Repas inclus"
            labelProps={{ fw: 600 }}
            value={mealPlan}
            onChange={setMealPlan}
            data={[
              { value: "none", label: "Aucun" },
              { value: "breakfast", label: "Petit déjeuner" },
              { value: "half_board", label: "Demi pension" },
              { value: "full_board", label: "Pension complète" }
            ]}
          />

          <NumberInput
            label="Annulation gratuite jusqu'à (heures)"
            labelProps={{ fw: 600 }}
            value={hoursBeforeArrival}
            onChange={setHoursBeforeArrival}
            min={0}
          />
          <Select
            label="Type d'annulation"
            value={policyType}
            onChange={setPolicyType}
            data={[
              { value: "free", label: "Annulation gratuite" },
              { value: "partial", label: "Annulation partielle" },
              { value: "non_refundable", label: "Non remboursable" }
            ]}
          />
          {policyType === "partial" && (
            <NumberInput
              label="Frais (%)"
              value={penaltyPercentage}
              onChange={setPenaltyPercentage}
              min={0}
              max={100}
            />
          )}
          {policyType !== "non_refundable" && (
            <NumberInput
              label="Annulation gratuite jusqu'à (heures)"
              value={hoursBeforeArrival}
              onChange={setHoursBeforeArrival}
              min={0}
            />
          )}

          <Stack>

            <Text fw={600}>Chambres concernées</Text>

            {rooms.map(room => (

              <Checkbox
                key={room._id}
                label={room.title}
                checked={selectedRooms.includes(room._id.toString())}
                onChange={() => handleRoomToggle(room._id)}
              />

            ))}

          </Stack>

          <Button
            type="submit"
            color="green"
            fullWidth
          >
            {isEdit ? "Mettre à jour" : "Créer le tarif"}
          </Button>

        </Stack>

      </form>

    </Drawer>

  );

};

export default RatePlansDrawer;